import React from 'react';
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core/styles";
import BaseButtonProps, {TColor} from "./interfaces/BaseButtonProps";

const useStyles = (props: {gutterBottom?: boolean, color?: TColor}) => makeStyles((theme : any) => ({
    root: {
        color: '#fff',
        backgroundColor: !!props.color
            ? theme.palette[props.color].main
            : (theme.palette.tertiary.main ? theme.palette.tertiary.main : theme.palette.primary.main),
        marginBottom: props.gutterBottom ? theme.spacing(2) : 0,
        '&:hover': {
            backgroundColor: !!props.color
                ? theme.palette[props.color].dark
                : theme.palette.tertiary.dark ? theme.palette.tertiary.dark : theme.palette.primary.dark
        }
    }
}))

export default function ContainedButton(props: BaseButtonProps) {
    const {
        gutterBottom,
        className,
        color,
        ...rest
    } = props;
    const classes = useStyles({gutterBottom, color})();

    return (
        <Button className={clsx(classes.root, !!className && className)}
                variant="contained"
                {...rest} />
    )
}